import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import PaymentTicket from './PaymentTicket';
import GatewayV2Services from '../../services/externalServices/TicketServices/gatewayV2Services';

export default function PaymentTicketV2(props) {
  const location = useLocation();
  const bookingId = location?.state?.bookingId;
  const [sending, setSending] = useState(false);
  const [qrUrl, setQrUrl] = useState('');
  const [err, setErr] = useState('');

  const sendV2 = async () => {
    if (!bookingId) { setErr('Missing booking id'); return; }
    setSending(true); setErr('');
    try {
      const res = await GatewayV2Services.sendTicket({ bookingId });
      const data = res?.data || res;
      if (data?.success) setQrUrl(data.qrUrl || ''); else setErr(data?.error || 'Failed');
    } catch (e) { setErr(e?.message || 'Send failed'); }
    finally { setSending(false); }
  };

  return (
    <div>
      <div className="p-3 bg-yellow-50 border-b border-yellow-200 text-sm flex items-center gap-3">
        <button onClick={sendV2} disabled={sending || !bookingId} className="px-3 py-1 bg-black text-white rounded">
          {sending ? 'Sending…' : 'Send Ticket (v2)'}
        </button>
        {qrUrl && <a href={qrUrl} target="_blank" rel="noreferrer" className="text-blue-600 underline">Open QR</a>}
        {err && <span className="text-red-600">{err}</span>}
        <span className="text-gray-600">Use this for dev-safe QR/WhatsApp per v2 policy/env.</span>
      </div>
      <PaymentTicket {...props} />
    </div>
  );
}
